<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <filter-manager
          v-model="searchModel.filters"
          ref="reportFilterRed"
          :filters="filterManagerConfig"
          @search="this.proceed"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process"
          :is-advanced="false"
        />
      </div>
    </div>
    <div class="row pl-3">
        <queue-report-status
          :queue-report="queueInfo"
          @on-cancel="cancelQueue"
          @on-download="downloadQueueReport"
        />
    </div>
  </div>
</template>


<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'
import Vue from 'vue';
import hubService from '@/services/api/hub/hubservice.js';
import queueReportTypes from '@/utils/constants/queueReportTypes';
import QueueReportStatus from '@/views/progress/shared/components/QueueReportStatus.vue';
import queueReportStatus from '@/utils/constants/queueReportStatus';

export default {
  components: {
    PageHeader,
    FilterManager,
    QueueReportStatus,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Indicador 13 (Servicios de Transición)',
      routes: ['Informes', 'Indicador 13 (Servicios de Transición)'],
    },
    searchModel: {
      collections: {
        academicYears: [],
      },
      filters: {
        academicYear: null,
      },
    },
    queueInfo: null,
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYears',
          component: 'CustomDropDown',
          options: this.searchModel.collections.academicYears,
          value: this.searchModel.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          label: 'Año Académico',
          placeholder: 'Seleccione',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          error: 'El campo Año Académico es obligatorio.',
        },
      ]
    },
  },
  async mounted() {
    this.initFilters()
    const res = await reportApi.getPreviousGeneratedReport([
      queueReportTypes.Indicador13EvaluacionDeServiciosDeTransicionExcel,
    ]);
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubService);
    this.$userHub.$on(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  methods: {
    async initFilters() {
      await CodeApiServices.GetTransitionalServicesEvaluationFilters().then(
        (res) => {
          this.searchModel = res.data
        }
      )
    },
    async proceed() {
      const isValid = await this.$refs.reportFilterRed.$refs.formValidator.validate();
      if (!isValid) return;
      const academicYearId = this.searchModel.filters.academicYear?.id;
      await reportApi.queueReport(
        `Indicador13EvaluacionDeServiciosDeTransicionExcel?academicYearId=${academicYearId}`
      ).then((res) => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false,
        };
      });
    },
    async downloadReport() {
      const isValid = await this.$refs.reportFilterRed.$refs.formValidator.validate() 
      if (isValid) {
        reportApi
          .getReport('getTransitionalServicesEvaluation', {
            AcademicYearId: this.searchModel.filters.academicYear.id,
          })
          .then((res) => {
            DocumentsService.Download(res.data)
          })
      }
    },
    onChangeAcademicYear(value) {
      this.searchModel.filters.academicYear = value
    },

    async cancelQueue(executionLogId) {
      reportApi.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    async downloadQueueReport(executionLogId) {
      reportApi.downloadQueueReport(executionLogId)
        .then((res) => DocumentsService.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
}
</script>